import i18n from 'config/i18n';

/**
 * Opens the support screen share in a new tab. `noopener` puts it in a separate browsing context
 * group (and, in Chromium, its own renderer process), so a crash, reload or logout in this tab does
 * not take the share down with it. The tab therefore gets no handle to this one; it only receives
 * the UI language.
 */
export const openSupportShareWindow = () => {
    const params = new URLSearchParams({ lng: i18n.language });
    window.open(`/support-share?${params}`, '_blank', 'noopener');
};
